import { ReactNode } from 'react';
import classnames from 'classnames';

import type { Icon } from '@personly/libs-types';
import { IconView } from '@personly/libs-widgets';

interface Props {
  children: ReactNode;
  icon?: Icon;
  legend: boolean;
  orientation: 'row' | 'column';
}

const TableHeader = ({ children, icon, legend, orientation }: Props) => {
  const className = classnames({
    flex: true,
    'flex-row': true,
    'flex-1': true,
    'place-items-center': true,
    'items-center': true,
    'font-bold': true,
    '!text-record-header-color':
      legend || (!legend && orientation === 'column'),
    'justify-center': orientation === 'row',
  });

  return (
    <div className={className}>
      <div className="flex">
        {icon && (
          <span className={'flex items-center pr-2'}>
            <IconView icon={icon} size="lg" />
          </span>
        )}
        {children}
      </div>
    </div>
  );
};

export default TableHeader;
